module.exports = __webpack_public_path__ + "static/img/img_0706.a0b2c38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0706.jpg
// module id = RauR
// module chunks = 0